import { atom } from 'recoil';
import Notification from '../../interfaces/Notification';

export default atom({
  key: 'notifications',
  default: [] as Notification[],
});
